import React, { Component } from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";

import { debounce } from "lodash";

import NavigationBar from "../components/NavigationBar";
import Banner from "../components/Banner";

import SpotlightWrapper from "../components/SpotlightWrapper";
import Spotlight from "../components/Spotlight";
import Content from "../components/Content";
import SpecialLink from "../components/SpecialLink";

class IndexPage extends Component {
  state = {
    isScrolled: false,
    isMounted: false
  };

  constructor(props) {
    super(props);
  }

  bannerRef = React.createRef();

  scrollListener = debounce(() => {
    const { clientHeight } = this.bannerRef.current;
    if (window.scrollY >= clientHeight) this.setState({ isScrolled: true });
    else this.setState({ isScrolled: false });
  }, 66);

  componentDidMount() {
    window.addEventListener("scroll", this.scrollListener);

    // trigger banner animation
    setTimeout(() => {
      this.setState({ isMounted: true });
    }, 50);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener);
  }

  render() {
    const { data, openMenu, langs, language } = this.props;
    return (
      <div className={this.state.isMounted ? "" : "is-preload"}>
        <NavigationBar
          siteTitle={data.site.siteMetadata.title}
          openMenu={openMenu}
          langs={langs}
          language={language}
          className={this.state.isScrolled ? "" : "alt"}
        />
        <Banner
          siteTitle={data.site.siteMetadata.title}
          ref={this.bannerRef}
          language={this.props.pathContext.langKey}
        />
        <SpotlightWrapper>
          <Spotlight>
            <Link to="Consulting" className="image">
              <Img sizes={data.consulting01.childImageSharp.sizes} />
            </Link>
            <Content>
              <h2 className="major">Consulting</h2>
              <p>
                Talent and organization services help companies increase their
                productivity, market share and shareholder value by ensuring
                they have the right people with the right skills in the right
                roles.
              </p>
              <SpecialLink to="Consulting">More</SpecialLink>
            </Content>
          </Spotlight>

          <Spotlight>
            <Link to="Outsourcing" className="image">
              <Img sizes={data.outsourcing03.childImageSharp.sizes} />
            </Link>
            <Content>
              <h2 className="major">Outsourcing</h2>
              <p>
                Business process outsourcing services involve the contracting of
                the operations and responsibilities of specific business
                functions (or processes) to a third-party service provider.
              </p>
              <SpecialLink to="Outsourcing">More</SpecialLink>
            </Content>
          </Spotlight>
        </SpotlightWrapper>
      </div>
    );
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.en.js